import { Link } from 'react-router-dom';

export default function SustainabilityHero() {
  return (
    <section className="relative w-full overflow-hidden bg-gradient-to-br from-brand-800 via-brand-700 to-brand-600">
      <div className="absolute inset-0 opacity-[0.04]"
        style={{
          backgroundImage: `url("data:image/svg+xml,%3Csvg width='80' height='80' viewBox='0 0 80 80' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23ffffff' fill-opacity='0.4'%3E%3Ccircle cx='40' cy='40' r='1.5'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`,
        }}
      ></div>

      <div className="absolute right-0 top-0 w-[45%] h-full hidden lg:block">
        <div className="absolute inset-0 bg-gradient-to-l from-transparent via-brand-800/30 to-brand-700/90"></div>
        <img
          src="https://readdy.ai/api/search-image?query=Sustainable%20cold%20chain%20logistics%20facility%20with%20solar%20panels%20on%20warehouse%20roof%2C%20green%20eco-friendly%20frozen%20food%20storage%2C%20modern%20industrial%20building%20surrounded%20by%20greenery%2C%20clean%20energy%20powered%20refrigeration%2C%20cinematic%20wide%20angle%2C%20warm%20natural%20lighting%2C%20environmental%20responsibility%20aesthetic&width=900&height=800&seq=sustainability-hero-01&orientation=portrait"
          alt="Sustainable cold chain facility"
          className="w-full h-full object-cover opacity-20"
        />
      </div>

      <div className="container-page relative z-10">
        <div className="flex flex-col lg:flex-row items-center min-h-[460px] md:min-h-[520px] py-16 md:py-20">
          <div className="w-full lg:w-3/5 text-center lg:text-left">
            <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-brand-500/40 border border-brand-400/30 mb-6">
              <div className="w-2 h-2 rounded-full bg-accent-400"></div>
              <span className="text-xs font-medium text-brand-100 uppercase tracking-widest">
                Sustainability
              </span>
            </div>

            <h1 className="font-heading text-3xl md:text-5xl lg:text-5xl font-bold text-paper-50 leading-tight mb-5 text-balance">
              Building a Cold Chain<br />That Respects the Planet.
            </h1>
            <p className="text-base md:text-lg text-brand-100/80 max-w-xl mx-auto lg:mx-0 mb-8 leading-relaxed">
              Every warehouse, every route, every delivery decision is an opportunity to reduce waste, cut emissions, and protect the resources that make India's food system possible.
            </p>

            <div className="flex flex-col sm:flex-row items-center gap-4 justify-center lg:justify-start">
              <Link
                to="/contact"
                className="px-8 py-3.5 bg-accent-500 hover:bg-accent-400 text-brand-800 font-semibold text-sm rounded-lg transition-all whitespace-nowrap cursor-pointer"
              >
                Partner With Us
              </Link>
              <a
                href="#commitments"
                className="px-8 py-3.5 border border-brand-300/50 hover:border-paper-50/80 text-paper-50 font-medium text-sm rounded-lg transition-all whitespace-nowrap cursor-pointer"
              >
                Our Commitments
              </a>
            </div>
          </div>
          <div className="hidden lg:block w-2/5"></div>
        </div>
      </div>
    </section>
  );
}